import type {
  VideosFetchForTopicAction,
  VideosFetchForTopicFailureAction,
  VideosFetchForTopicSuccessAction,
} from "entities/videos/actionTypes";
import { VideoActionTypes } from "entities/videos/actionTypes";

export const fetchVideosForTopic = (
  payload: VideosFetchForTopicAction["payload"],
  meta?: VideosFetchForTopicAction["meta"],
): VideosFetchForTopicAction => ({
  type: VideoActionTypes.FETCH_FOR_TOPIC,
  meta: meta ?? { forceRefresh: false },
  payload,
});

export const fetchVideosForTopicSuccess = (
  payload: VideosFetchForTopicSuccessAction["payload"],
  meta: VideosFetchForTopicSuccessAction["meta"],
): VideosFetchForTopicSuccessAction => ({
  type: VideoActionTypes.FETCH_FOR_TOPIC_SUCCESS,
  payload,
  meta,
});

export const fetchVideosForTopicFailure = (
  meta: VideosFetchForTopicFailureAction["meta"],
): VideosFetchForTopicFailureAction => ({ meta, type: VideoActionTypes.FETCH_FOR_TOPIC_FAILURE });
